import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import IntegerInput from "commons/ui/input/IntegerInput";
import Select from "commons/ui/input/Select";
import Paper from "commons/ui/Paper";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";

import useMaterialCategoryForm from "hooks/form/useMaterialCategoryForm";

import { IndoorOrOutdoor } from "types/enums";

function MaterialCategoryForm({ materialCategoryId }: { materialCategoryId?: string }) {
    const { formHook } = useMaterialCategoryForm({ materialCategoryId });

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridItem>
            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <Paper>
                        <GridColumn>
                            <GridRow className="title-margin">
                                <GridItem>
                                    <h2>Impostazioni</h2>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-3"}>
                                    <Select
                                        label={"Tipologia"}
                                        options={[
                                            { value: IndoorOrOutdoor.indoor, label: "Indoor" },
                                            { value: IndoorOrOutdoor.outdoor, label: "Outdoor" },
                                        ]}
                                        value={form.type}
                                        setValue={setValue}
                                        path={"type"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-2"}>
                                    <IntegerInput
                                        label={"Ordine"}
                                        value={form.graphical_order}
                                        setValue={setValue}
                                        path={"graphical_order"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>

                            <GridRow className="title-margin">
                                <GridItem>
                                    <h2>Italiano</h2>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        label={"Nome"}
                                        startAdornment={TwoLanguagesAdornment("it")}
                                        value={form.text.it.name}
                                        setValue={setValue}
                                        path={"text.it.name"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>

                            <GridRow className="title-margin">
                                <GridItem>
                                    <h2>Inglese</h2>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        label={"Nome"}
                                        startAdornment={TwoLanguagesAdornment("en")}
                                        value={form.text.en.name}
                                        setValue={setValue}
                                        path={"text.en.name"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>
                        </GridColumn>
                    </Paper>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

export default MaterialCategoryForm;
